import React from "react";
import "./Footer.scss";
import logo from "../../images/logo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <a href="#inicio" className="footer__logo">
              <img
                src={logo}
                alt="Yare And San Industry"
              />
            </a>

            <p className="footer__description">
              Soluciones en vidrio y aluminio para proyectos residenciales y
              comerciales, desarrolladas con calidad, diseño y atención al
              detalle.
            </p>
          </div>

          <div className="footer__links-group">
            <h3 className="footer__title">Navegación</h3>
            <ul className="footer__links">
              <li>
                <a href="#inicio">Inicio</a>
              </li>
              <li>
                <a href="#servicios">Servicios</a>
              </li>
              <li>
                <a href="#proyectos">Proyectos</a>
              </li>
              <li>
                <a href="#por-que-elegirnos">Nosotros</a>
              </li>
              <li>
                <a href="#contacto">Contacto</a>
              </li>
            </ul>
          </div>

          <div className="footer__links-group">
            <h3 className="footer__title">Servicios</h3>
            <ul className="footer__links">
              <li>Canceles de cristal templado</li>
              <li>Puertas y ventanas de aluminio</li>
              <li>Barandales de vidrio</li>
              <li>Divisiones para oficina</li>
              <li>Fachadas y proyectos especiales</li>
            </ul>
          </div>

          <div className="footer__contact">
            <h3 className="footer__title">Contacto</h3>

            <div className="footer__contact-list">
              <div className="footer__contact-item">
                <span>WhatsApp</span>
                <a
                  href="https://wa.me/525566176657"
                  target="_blank"
                  rel="noreferrer"
                >
                  55 6617 6657
                </a>
              </div>

              <div className="footer__contact-item">
                <span>Zona de atención</span>
                <p>Ciudad de México y Área Metropolitana</p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© 2026 Yare And San Industry. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;